// extracted by mini-css-extract-plugin
export default {"dropdownItemSm":"qspcX4oDsIMYKzM_vgTA2","dropdownItemLg":"_2t6DTa_tw6k18-6NSKG-nA","dropdownItemXl":"_5wqZYM8wErbiTxOCek_BL"};